import { getAngularService } from './Utilities';

let recovery: {token: string | null; promise: PromiseLike<void>} | null = null;

export function getSessionToken(): string | null {
  const storage = getAngularService<Record<string, string | null>>('$localStorage');
  const tokenName = getAngularService<string>('token_cookie_name');
  return tokenName ? storage?.[tokenName] || null : null;
}

export async function fetchSessionJson<T>(url: string, failureMessage: string): Promise<T> {
  const token = getSessionToken();
  const response = await fetch(url, {
    method: 'GET',
    credentials: 'include',
    headers: {
      'Content-Type': 'application/json',
      ...(token ? {Authorization: `Bearer ${token}`} : {}),
    },
  });

  if (!response.ok) {
    throw new Error(`${failureMessage}: ${response.status} ${response.statusText}`.trim());
  }

  const data = await response.json() as T & {error?: {type?: string}};
  if (data?.error?.type === 'session_error') {
    // An old request must not log out a session created while it was in flight.
    if (getSessionToken() === token) {
      const login = getAngularService<{logout: () => PromiseLike<void>}>('loginService');
      if (login) {
        // The Library and its permission request can fail together.
        if (!recovery || recovery.token !== token) {
          recovery = {token, promise: login.logout()};
        }
        const pending = recovery;
        try {
          await pending.promise;
        } finally {
          if (recovery === pending) {
            recovery = null;
          }
        }
      }
    }
    throw new Error('Your session has expired. Please sign in again.');
  }

  return data;
}
